import ListRow from '../../ListRow'
import ListRowAction from '../../ListRowAction'
import CaptureIcon from '../../../assets/icons/capture'
import CopyIcon from '../../../assets/icons/copy'
import PlayIcon from '../../../assets/icons/play'
import { play, addCaptureItem } from '../../../api/endpoints'
import type { PlaylistChannel } from '@expostreamer/shared-types'

interface ChannelItemProps {
  item: PlaylistChannel
  // Shorter label (e.g. episode without the series name inside a series
  // group); the full name stays available as the hover tooltip.
  label?: string
  onChannelItemClick?: (url: string) => void
}

function ChannelItem({ item, label, onChannelItemClick }: ChannelItemProps) {
  return (
    <ListRow
      label={label ?? item.name}
      tooltip={item.name}
      onClick={() => {
        play({ videoSource: item.url })
      }}
      actions={
        <>
          <ListRowAction
            onClick={() => {
              addCaptureItem({
                fileName: encodeURI(item.name ?? '') + '.mp4',
                url: item.url,
                duration: 0,
              })
            }}
          >
            <CaptureIcon size={20} />
          </ListRowAction>
          <ListRowAction
            onClick={() => {
              navigator.clipboard.writeText(item.url)
            }}
          >
            <CopyIcon size={20} />
          </ListRowAction>
          <ListRowAction
            onClick={() => {
              onChannelItemClick?.(item.url)
            }}
          >
            <PlayIcon size={20} />
          </ListRowAction>
        </>
      }
    />
  )
}

export default ChannelItem
